import { render, staticRenderFns } from "./deleteProxy.vue?vue&type=template&id=1d389456&lang=pug&"
import script from "./deleteProxy.vue?vue&type=script&lang=js&"
export * from "./deleteProxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports